import React, { useEffect, useState } from "react";
import useMap from "../../hooks/useOpenLayersMap";
import MapFullScreen from "../../map/mapFullScreen";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { ConvertDfrToFeatures, JumpToFeatures } from "../../map/mapUtil";
import { useUserAuth } from "../../contexts/authContext";

export default function DfrPreview(props) {
    const MAP_ID = "map-dfr-preview";
    const map = useMap(MAP_ID, false);
    const [dfr] = useState(props.dfr);
    const [telemetry, setTelemetry] = useState([]);
    const { userMapSettings, handleFailedFetch } = useUserAuth();

    useEffect(() => {
        if (!dfr.telemetry) {
            return;
        }

        const fetchData = async () => {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            };
            await fetch(`/api/telemetry/get/${dfr.flight_uuid}`, requestOptions)
                .then((response) => (response.ok ? response.json() : Promise.reject(response)))
                .then((data) => setTelemetry(data))
                .catch((err) => handleFailedFetch(err));
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (!map || (dfr.telemetry && (!Array.isArray(telemetry) || telemetry.length === 0))) {
            return;
        }

        const features = ConvertDfrToFeatures(dfr, telemetry, userMapSettings);
        const source = new VectorSource({ features });
        map.addLayer(new VectorLayer({ source }));
        JumpToFeatures(map, features);
    }, [map, telemetry]);

    const handleUnpublish = () => {
        if (!confirm("Are you sure you want to unpublish this DFR?")) {
            return;
        }

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...dfr, published: false })
        };
        fetch("/api/dfr/insertUpdate", requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then(() => {
                props.fetchDFR();
                handleClose();
            })
            .catch((err) => handleFailedFetch(err));
    };

    const handleClose = () => {
        props.setDfrPreviewOpen(false);
    };

    return (
        <Dialog open={true} onClose={handleClose} fullWidth>
            <DialogTitle>DFR Preview - {dfr.name}</DialogTitle>
            <DialogContent sx={{ display: "flex", flexDirection: "column", width: "100%", height: "500px", pb: 0 }}>
                <Box sx={{ flex: 1 }}>
                    <MapFullScreen map_id={MAP_ID} map={map} />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", m: 1, mt: 0, gap: 2 }}>
                    <Box sx={{ display: "flex", pt: "20px", gap: "10px" }}>
                        <TextField label="Case/Incident" value={dfr.incident} size="small" fullWidth disabled />
                        <TextField label="Location" value={dfr.location} size="small" fullWidth disabled />
                    </Box>
                    <TextField label="Summary" value={dfr.summary} size="small" fullWidth multiline disabled />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} sx={{ mr: "auto" }}>
                    Close
                </Button>
                <Button onClick={handleUnpublish}>Unpublish</Button>
            </DialogActions>
        </Dialog>
    );
}
